/*
 * @Author: Json Chen
 * @Date: 2021-07-14 09:08:07
 * @LastEditTime: 2021-10-13 15:50:45
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/logistics/courieraccount.ts
 */

import { get, post, remove } from 'src/tools/server';

export const getCourierList = (warehouseUuid, params?) => {
  return get<any>(
    `/portal/setting/store/logistics/couriers/${warehouseUuid}`,
    params || {},
  );
};

export const getCourierDetail = (uuid) => {
  return get<any>(`/portal/setting/store/logistics/courier/${uuid}`, {});
};

export const delCourier = (uuid) => {
  return remove<any>(`/portal/setting/store/logistics/courier/${uuid}`, {});
};

// onSave
export const setCourier = (body: any) => {
  return post<any>(`/portal/setting/store/logistics/courier`, body, {});
};
